<template>
  <div class="bg-light">
    <div class="livraison-page container">
      <div class="bg-light">
        <div class="container section-header-breadcrumb">
          <div class="row">
            <div class="content text-left col-sm-12 col-md-12 col-lg-12">
              <h2 class="title-page">
                <span class="back-link cursor-pointer" @click="BackToLivraison">
                  <i class="ti ti-back-left font-20 orange-color pe-2"></i>
                </span>
                Mode de paiement
              </h2>
              <label class="breadcrumb-text">
                <span class="pointer-cursor" @click.prevent="GoToDashboard">Accueil</span> >
                <span class="pointer-cursor" @click.prevent="GoToStepCart">Mon panier</span> >
                <span class="cursor-pointer" @click="BackToLivraison"> Livraison > </span>
                <span>Paiement</span>
              </label>
            </div>
          </div>
        </div>

        <div class="content d-flex flex-column flex-lg-row gap-4 gap-lg-5 mb-4 cart-page-inner">
          <div class="col-12 col-lg-8 block-adresses">
            <!-- Steps - Même approche que les autres composants -->
            <div class="row step-cart ps-5 pe-5">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="d-flex gap-4 align-items-center py-4 step-cart-centent">
                  <div class="step-number" @click.prevent="GoToStepCart">
                    <span class="badge mx-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-100 h-75"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="#ec621a"
                        stroke-width="3"
                      >
                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    </span>
                    <span class="step-title">Votre panier</span>
                  </div>
                  <div class="separator"></div>
                  <div class="step-number">
                    <span class="badge mx-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-100 h-75"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="#ec621a"
                        stroke-width="3"
                      >
                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    </span>
                    <span class="step-title">Livraison</span>
                  </div>
                  <div class="separator"></div>
                  <div class="step-number">
                    <span class="badge badge-blue mx-2">3</span>
                    <span class="step-title">Paiement</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Champ de sélection de date d'expédition pour les délégués -->
            <div v-if="isDelegue" class="row justify-content-center">
              <div class="col-12 col-lg-10 my-2">
                <div class="shipping-date-section">
                  <h4 class="title-blue text-center text-lg-start">Date d'expédition de la commande</h4>
                  <div class="form-input">
                    <label class="label-control"
                      >Sélectionnez la date à partir de laquelle la commande sera expédiée *</label
                    >
                    <input
                      type="date"
                      class="form-control round-15"
                      v-model="shippingDate"
                      :min="minShippingDate"
                      :max="maxShippingDate"
                      required
                    />
                    <div v-if="!shippingDate && showShippingDateError" class="error-message">
                      Veuillez sélectionner une date d'expédition
                    </div>
                    <div v-if="shippingDate" class="shipping-date-info">
                      La commande sera expédiée à partir du <strong>{{ formatDate(shippingDate) }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Modes de paiement -->
            <div class="row justify-content-center modes-livraison">
              <div class="col-12 col-lg-10 my-2">
                <div class="mode-paiement">
                  <div v-if="isLoadingPayments" class="text-center blue-color">
                    <span>Chargement des modes de paiement...</span>
                  </div>
                  <div v-else-if="!modes.length" class="text-center">
                    <span>Aucun mode de paiement disponible</span>
                  </div>
                  <label
                    v-else
                    v-for="mode in modes"
                    :key="mode.id"
                    class="adress-box"
                    :class="{ selected: selectedMode === mode.id }"
                    v-show="selectedPaymentMethod?.code !== 'sylius_mol1'"
                  >
                    <input
                      type="radio"
                      name="modePaiement"
                      class="radio-hidden"
                      :value="mode.id"
                      v-model="selectedMode"
                    />

                    <div class="mode-left">
                      <div class="radio-visible">
                        <div class="circle" :class="{ active: selectedMode === mode.id }"></div>
                      </div>
                      <div class="mode-info">
                        <strong>{{ mode.titre }}</strong
                        ><br />
                        <span v-if="mode.description">{{ mode.description }}</span>
                        <span v-if="mode.instructions" class="instructions">{{ mode.instructions }}</span>
                      </div>
                    </div>
                  </label>

                  <div
                    v-if="
                      !isLoadingPayments &&
                      (isVeterinaire || isDelegue) &&
                      selectedMode &&
                      selectedPaymentMethod?.code === 'sylius_mol1' &&
                      selectedPaymentMethod?.mollie?.configuration?.length
                    "
                  >
                    <h4 class="title-blue mt-4 text-center text-lg-start">Choisissez un type de paiement</h4>
                    <div class="mollie-payment-types">
                      <label
                        v-for="mollieMethod in selectedPaymentMethod.mollie.configuration"
                        :key="mollieMethod.methodId"
                        class="adress-box"
                        :class="{ selected: selectedMollieMethod === mollieMethod.methodId }"
                      >
                        <input
                          type="radio"
                          name="molliePaymentMethod"
                          class="radio-hidden"
                          :value="mollieMethod.methodId"
                          v-model="selectedMollieMethod"
                        />
                        <div class="mode-left">
                          <div class="radio-visible">
                            <div
                              class="circle"
                              :class="{ active: selectedMollieMethod === mollieMethod.methodId }"
                            ></div>
                          </div>
                          <div class="mode-info">
                            <strong>{{ mollieMethod.payment_name }}</strong>
                          </div>
                        </div>
                        <div class="mode-right">
                          <img :src="mollieMethod.payment_images.svg" alt="mollie payment logo" class="logo-paiement" />
                        </div>
                      </label>
                    </div>
                    <div v-if="isUpdatingMollieMethod" class="text-center blue-color mt-2">
                      <span>Mise à jour du type de paiement...</span>
                    </div>
                    <div v-if="mollieUpdateError" class="text-center error mt-2">
                      <span>{{ mollieUpdateError }}</span>
                    </div>
                  </div>

                  <!-- Bloc adresses -->
                  <div v-if="isLoadingOrder" class="text-center my-4 blue-color">
                    <span>Chargement des adresses…</span>
                  </div>
                  <div class="container-adresse" v-else>
                    <!-- Adresse de Livraison -->
                    <div class="adresse-card">
                      <div class="d-flex align-items-center mb-2 justify-content-center justify-content-lg-start">
                        <img :src="iconlocation" class="shipping-icon" />
                        <label class="title-blue my-auto px-2 text-center text-lg-start">Adresse de Livraison</label>
                      </div>
                      <div class="adresse-livraison">
                        <div class="location d-flex">
                          <div class="detail-adresse" v-if="adresseLivraisonView">
                            {{ adresseLivraisonView.firstName }} {{ adresseLivraisonView.lastName }} <br />
                            <span v-if="adresseLivraisonView.company">{{ adresseLivraisonView.company }}<br /></span>
                            <span v-if="adresseLivraisonView.phoneNumber">
                              téléphone : {{ adresseLivraisonView.phoneNumber }}</span
                            ><br v-if="adresseLivraisonView.phoneNumber" />
                            <span v-if="relay_id">code point de relais : {{ relay_id }} </span> <br v-if="relay_id" />
                            {{ adresseLivraisonView.street }}, <br />{{ adresseLivraisonView.postcode }}
                            {{ adresseLivraisonView.city }} <br />
                            {{ adresseLivraisonView.countryCode }}<br />
                          </div>
                          <div class="detail-adresse" v-else>Aucune adresse de livraison définie</div>
                        </div>
                      </div>
                    </div>

                    <!-- Adresse de Facturation -->
                    <div class="adresse-card">
                      <div class="d-flex align-items-center mb-2 justify-content-center justify-content-lg-start">
                        <img :src="iconlocation" class="shipping-icon" />
                        <label class="title-blue my-auto px-2 text-center text-lg-start">Adresse de Facturation</label>
                      </div>
                      <div class="adresse-livraison">
                        <div class="location d-flex">
                          <div class="detail-adresse" v-if="adresseFacturationView">
                            {{ adresseFacturationView.firstName }} {{ adresseFacturationView.lastName }} <br />
                            <span v-if="adresseFacturationView.company"
                              >{{ adresseFacturationView.company }}<br
                            /></span>
                            {{ adresseFacturationView.street }}, <br />{{ adresseFacturationView.postcode }}
                            {{ adresseFacturationView.city }} <br />
                            {{ adresseFacturationView.countryCode }}
                          </div>
                          <div class="detail-adresse" v-else>Aucune adresse de facturation définie</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Commentaire -->
                  <div class="form-input mt-4 text-start">
                    <label class="label-control">Commentaire (facultatif)</label>
                    <p class="fw-bold text-start" style="font-size: 0.9em; color: #1e347d">
                      Merci de ne pas fournir d'instructions de livraison, nous ne pouvons pas les transmettre au
                      transporteur. Vous pourrez les transmettre directement via leurs e-mails de suivi.
                    </p>
                    <textarea class="form-control round-15" rows="2" v-model="comment"></textarea>
                  </div>

                  <!-- Logos sécurité -->
                  <div class="row justify-content-center mt-4">
                    <div class="col-12 col-lg-4">
                      <div class="d-flex gap-3 justify-content-center">
                        <img :src="ssl" alt="SSL Secure" />
                        <img :src="verfied" alt="Visa Verified" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Bloc récap -->
          <div class="col-12 col-lg-4 py-3 block-recap">
            <label class="title-recap">Récapitulatif de la commande</label>

            <div v-if="showWarehouseNotice" class="alert alert-info my-3">
              <i class="ti ti-info-circle"></i>
              <p>
                <strong>Information :</strong> Suite à un arrêté préfectoral en lien avec l'épisode de froid en cours,
                les transporteurs ne sont pas autorisés à circuler dans la région de notre entrepôt logistique avant la
                fin de journée du 06 janvier, au plus tôt. Cela peut donc entrainer un léger retard dans la prise en
                charge de vos commandes par ces derniers.
              </p>
            </div>

            <div class="my-3 my-md-4 d-flex justify-content-between align-items-center">
              <label class="recap-text p-0">Prix des produits</label>
              <span class="recap-text">{{ (TotalCart / 100).toFixed(2) }} € HT </span>
            </div>

            <div class="my-3 my-md-4 d-flex justify-content-between align-items-center" v-if="showRemiseLine && remise">
              <p class="col-6 col-lg-6 p-0">
                <label class="recap-text">Remise</label>
                <br />
                <span class="text-slogan" v-if="couponCode"> {{ couponCode }} </span>
                <span class="text-slogan" v-else>inclus dans le prix des produits</span>
              </p>
              <span class="recap-text">{{ remise }} €</span>
            </div>

            <div class="my-3 my-md-4 d-flex justify-content-between align-items-center" v-if="tvaTieCode === '0'">
              <label class="recap-text p-0">TVA</label>
              <span class="recap-text">{{ (Tva / 100).toFixed(2) }} €</span>
            </div>

            <div class="my-3 my-md-4 row">
              <div class="d-flex justify-content-between align-items-center">
                <p>
                  <label class="recap-text">Livraison</label>
                  <br />
                  <span v-if="(shippingTotal / 100).toFixed(2) !== '0.00'" class="text-slogan">Tva inclus</span>
                </p>

                <span class="recap-text">
                  <span v-if="(shippingTotal / 100).toFixed(2) === '0.00'" class="orange-color"> Offerte </span>
                  <span v-else> {{ (shippingTotal / 100).toFixed(2) }}€ </span>
                </span>
              </div>
            </div>
            <hr class="divider" />
            <div class="my-3 my-md-4 d-flex justify-content-between align-items-center" v-if="tvaTieCode === '0'">
              <label class="recap-text">Total TVA inclus</label>
              <span class="recap-text-blue px-0">{{ (TotalCartTTC / 100).toFixed(2) }} € TTC</span>
            </div>
            <div class="my-3 my-md-4 d-flex justify-content-between align-items-center" v-else>
              <label class="recap-text">Total</label>
              <span class="recap-text-blue px-0">{{ (TotalCartTTC / 100).toFixed(2) }} € HT</span>
            </div>

            <div class="form-input mt-4">
              <label>
                <input type="checkbox" v-model="acceptTerms" />
                J'accepte
                <a
                  :href="
                    isVeterinaire || isDelegue ? '/page/17-cgv-veterinaires' : isProfessional ? lienpro : lienconso
                  "
                  target="_blank"
                >
                  les conditions générales de vente
                </a>
              </label>
            </div>

            <div class="row">
              <div class="col-12 text-center">
                <button
                  class="btn text-white btn-check-order mt-2 w-100 w-lg-60"
                  :disabled="!canConfirmOrder || hasRestrictedShippingCountry || isProcessingOrder"
                  @click="ConfirmCommande"
                >
                  <span
                    v-if="isProcessingOrder"
                    class="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span>{{ isProcessingOrder ? "Traitement en cours..." : "Confirmer" }}</span>
                </button>
              </div>
              <div class="col-12 text-center mt-2">
                <span class="text-slogan mt-3">Paiement 100% sécurisé avec technologies SSL et 3D Secure.</span>
              </div>
            </div>

            <!-- Message d'information pour les pays restreints -->
            <div v-if="hasRestrictedShippingCountry" class="alert alert-warning mt-3">
              <i class="ti ti-alert-triangle me-2"></i>
              {{ restrictedCountryMessage }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import user from "@/assets/images/user.svg";
  import iconlocation from "@/assets/location.svg";
  import { useCheckoutStore } from "@/stores/useCheckoutStore";
  import ssl from "@/assets/images/ssl-secure.svg";
  import verfied from "@/assets/images/Visa-verified.svg";
  import {
    fetchPaymentMethods,
    updatePaymentMethod,
    createMolliePayment,
    createMolliePaymentVeto,
    updateMolliePaymentMethod,
    completeOrder,
    submitSameAsComplete,
  } from "@/api/orders";
  import { useCartStore } from "@/stores/cartStore";
  import AuthService from "@/services/authService";
  import { useRegisterStore } from "@/stores/register";
  import { useDelegueStore } from "@/stores/delegueStore";
  import { useToast } from "vue-toastification";

  export default {
    name: "ModePaiement",
    setup() {
      // Get toast interface
      const toast = useToast();
      return { toast };
    },
    data() {
      return {
        selectedMode: null,
        selectedMollieMethod: null,
        modes: [],
        comment: "",
        acceptTerms: false,
        ssl,
        verfied,
        isLoadingPayments: false,
        isProcessingOrder: false,
        isLoadingOrder: true,
        isUpdatingMollieMethod: false,
        mollieUpdateError: null,
        mollieUpdateSuccess: false,
        iconlocation,
        user,
        registerStore: null,
        lienpro: process.env.VUE_APP_TERMS_LINK_PRO,
        lienconso: process.env.VUE_APP_TERMS_LINK_CONS,
        shippingDate: null,
        showShippingDateError: false,
        previousShippingCountry: null,
      };
    },
    computed: {
      isVeterinaire() {
        return AuthService.isVeterinaire();
      },

      isDelegue() {
        return this.registerStore?.user?.role === "delegues";
      },

      TotalCart() {
        const checkoutStore = useCheckoutStore();
        return checkoutStore.order?.itemsSubtotal || 0;
      },

      relay_id() {
        const checkoutStore = useCheckoutStore();
        return checkoutStore.order?.relay_id || null;
      },

      TotalCartTTC() {
        const checkoutStore = useCheckoutStore();
        return checkoutStore.order?.total || 0;
      },

      Tva() {
        const checkoutStore = useCheckoutStore();
        return (
          checkoutStore.order?.taxTotal -
            (checkoutStore.order?.shippingTotal - checkoutStore.order?.shippingTaxTotal) || 0
        );
      },

      remise() {
        var total = 0;
        var checkoutStore = useCheckoutStore();
        total = checkoutStore.order.orderPromotionTotal / 100;
        return total ? this.formatPrice(total) : 0;
      },

      couponCode() {
        const checkoutStore = useCheckoutStore();
        return checkoutStore.order?.coupon_code || "";
      },

      tvaTieCode() {
        const checkoutStore = useCheckoutStore();
        return checkoutStore.order?.tvaTieCode;
      },

      shippingTotal() {
        const checkoutStore = useCheckoutStore();
        return checkoutStore.order?.shippingTotal || 0;
      },

      selectedPaymentMethod() {
        return this.modes.find(mode => mode.id === this.selectedMode) || null;
      },

      // Vérifie si l'adresse de livraison est dans un pays restreint
      hasRestrictedShippingCountry() {
        const shippingCountry = this.adresseLivraisonView?.countryCode;

        console.log(this.livraisonAlaClinique, shippingCountry);

        // Pour les vétérinaires et délégués : seulement la Suisse est restreinte
        if (this.isVeterinaire || this.isDelegue) {
          if (this.livraisonAlaClinique === "OLD1ID") {
            return false;
          }
          return shippingCountry === "CH";
        }

        // Pour les autres utilisateurs : only France
        return shippingCountry !== "FR";
      },

      // Message d'information pour les pays restreints
      restrictedCountryMessage() {
        const country = this.adresseLivraisonView?.countryCode;
        if (country === "BE") {
          return "Les commandes vers la Belgique ne sont pas disponibles pour votre profil. Veuillez contacter notre service client pour plus d'informations.";
        } else if (country === "CH") {
          return "Les commandes vers la Suisse ne sont pas disponibles pour votre profil. Veuillez contacter notre service client pour plus d'informations.";
        }
        return "Les commandes sur votre profil sont disponibles uniquement pour la France. Veuillez contacter notre service client pour plus d’informations.";
      },

      canConfirmOrder() {
        // Si l'utilisateur a une adresse de livraison restreinte, empêcher la confirmation
        if (this.hasRestrictedShippingCountry) {
          return false;
        }

        // Require Mollie payment method update success for sylius_mol1 and isVeterinaire
        if ((this.isVeterinaire || this.isDelegue) && this.selectedPaymentMethod?.code === "sylius_mol1") {
          return (
            this.selectedMode !== null &&
            this.selectedMollieMethod !== null &&
            this.mollieUpdateSuccess &&
            this.acceptTerms &&
            !this.isProcessingOrder
          );
        }
        return this.selectedMode !== null && this.acceptTerms && !this.isProcessingOrder;
      },

      adresseLivraisonView() {
        const checkoutStore = useCheckoutStore();
        return checkoutStore.order?.shippingAddress || null;
      },

      livraisonAlaClinique() {
        const checkoutStore = useCheckoutStore();
        return checkoutStore.shippingMethod || null;
      },

      adresseFacturationView() {
        const checkoutStore = useCheckoutStore();
        return checkoutStore.order?.billingAddress || null;
      },

      isProfessional() {
        return this.registerStore?.clientInfo?.professionnel || false;
      },

      minShippingDate() {
        return new Date().toISOString().split("T")[0];
      },

      maxShippingDate() {
        const maxDate = new Date();
        maxDate.setMonth(maxDate.getMonth() + 3);
        return maxDate.toISOString().split("T")[0];
      },

      showWarehouseNotice() {
        const today = new Date();
        const deadline = new Date("2026-01-07T00:00:00");
        return today < deadline;
      },
      showRemiseLine() {
        const order = useCheckoutStore().order;
        const subtotal = order?.itemsSubtotal || 0;
        const remiseValue = Math.abs(order?.orderPromotionTotal || 0);
        return subtotal > 0 && remiseValue > 0 && remiseValue < subtotal;
      },
    },
    watch: {
      selectedMollieMethod(newValue) {
        if ((this.isVeterinaire || this.isDelegue) && this.selectedPaymentMethod?.code === "sylius_mol1" && newValue) {
          this.updateMolliePayment();
        }
      },

      selectedMode(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.selectedMollieMethod = null;
          this.mollieUpdateSuccess = false;
          this.mollieUpdateError = null;
          this.isUpdatingMollieMethod = false;
        }
      },

      adresseLivraisonView: {
        handler(newAddress) {
          if (newAddress && this.hasRestrictedShippingCountry) {
            this.showRestrictedCountryToast();
          }
        },
      },
    },

    mounted() {
      this.loadPaymentMethods();
      this.registerStore = useRegisterStore();
    },

    methods: {
      formatDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString("fr-FR", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        });
      },

      formatPrice(value) {
        if (value == null || isNaN(value)) return "0,00";
        const num = Number(value);
        return num.toFixed(2).replace(".", ",");
      },

      GoToStepCart() {
        this.$router.push({ name: "my-cart" });
      },

      BackToLivraison() {
        this.$router.push({ name: "livraison" });
      },

      GoToDashboard() {
        this.$router.push({ name: "dashboard-home" });
      },

      // Afficher un toast informatif pour les pays restreints
      showRestrictedCountryToast() {
        this.toast.warning(this.restrictedCountryMessage, {
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
      },

      async loadPaymentMethods() {
        await useCartStore().fetchCart();
        const checkoutStore = useCheckoutStore();
        let order = checkoutStore.order;

        this.isLoadingPayments = true;
        this.isLoadingOrder = true;

        try {
          const delegueStore = useDelegueStore();
          const registerStore = useRegisterStore();
          const vetId = delegueStore.getSelectedVeterinarian?.id;
          const userRole = registerStore.user?.role || "";
          const paymentMethods = await fetchPaymentMethods(order, userRole, vetId);
          this.modes = paymentMethods.map(method => ({
            ...method,
          }));

          if (this.modes.length > 0) {
            this.selectedMode = this.modes[0].id;
            const paymentId = order.payments[0]?.id;
            if (paymentId) {
              const delegueStore = useDelegueStore();
              const registerStore = useRegisterStore();
              const vetId = delegueStore.getSelectedVeterinarian?.id;
              const userRole = registerStore.user?.role || "";
              await updatePaymentMethod(
                order.tokenValue,
                paymentId,
                this.modes[0].code,
                order.shipments[0]?.method,
                userRole,
                vetId
              );
            }
          }
        } catch (error) {
          console.error("Erreur loadPaymentMethods :", error);
        } finally {
          this.isLoadingPayments = false;
          this.isLoadingOrder = false;
        }
      },

      async updateMolliePayment() {
        if (!this.selectedMollieMethod || !this.selectedPaymentMethod) return;

        const checkoutStore = useCheckoutStore();
        const orderToken = checkoutStore.order?.tokenValue;

        if (!orderToken) {
          console.error("Order token missing.");
          this.mollieUpdateError = "Erreur : jeton de commande manquant.";
          return;
        }

        this.isUpdatingMollieMethod = true;
        this.mollieUpdateError = null;
        this.mollieUpdateSuccess = false;

        try {
          await updateMolliePaymentMethod(orderToken, this.selectedPaymentMethod.code, this.selectedMollieMethod);
          this.mollieUpdateSuccess = true;
        } catch (error) {
          console.error("Error updating Mollie payment method:", error.response?.data || error.message);
          this.mollieUpdateError = "Erreur lors de la mise à jour du type de paiement Mollie.";
        } finally {
          this.isUpdatingMollieMethod = false;
        }
      },

      async ConfirmCommande() {
        if (this.isProcessingOrder) return;

        // Vérifier si l'adresse de livraison est restreinte
        if (this.hasRestrictedShippingCountry) {
          this.showRestrictedCountryToast();
          return;
        }

        if (!this.canConfirmOrder) {
          console.error("Cannot confirm order: missing payment method, Mollie method update, or terms acceptance.");
          return;
        }

        const checkoutStore = useCheckoutStore();
        const cartStore = useCartStore();
        const delegueStore = useDelegueStore();
        const orderToken = checkoutStore.order?.tokenValue;
        const selectedPaymentMethod = this.modes.find(mode => mode.id === this.selectedMode);

        if (!orderToken || !selectedPaymentMethod) {
          console.error("Missing order token or payment method.");
          return;
        }

        this.isProcessingOrder = true;

        try {
          const paymentId = checkoutStore.order.payments[0]?.id;
          const isMolliePayment = selectedPaymentMethod.code === "sylius_mol1";
          const isMolliePaymentV2 = selectedPaymentMethod.code === "sylius_MOL2";

          // Update payment method for non-Mollie cases
          if (paymentId && !isMolliePayment) {
            await updatePaymentMethod(
              orderToken,
              paymentId,
              selectedPaymentMethod.code,
              checkoutStore.order.shipments[0]?.method
            );
          }

          // Handle Mollie payment veto for veterinary case
          if (isMolliePayment && (this.isVeterinaire || this.isDelegue)) {
            console.log("Submitting notes/date before Veto payment...");
            await submitSameAsComplete(orderToken, this.comment, this.isDelegue ? this.shippingDate : null);

            const mollieVetoResponse = await createMolliePaymentVeto(orderToken, paymentId);

            // Check for success: false in 201/200 response
            if (mollieVetoResponse?.data?.success === false) {
              const err = new Error(mollieVetoResponse.data.error || "Mollie payment configuration failed");
              err.response = mollieVetoResponse;
              throw err;
            }

            const { data: { redirectUrl } = {} } = mollieVetoResponse || {};
            if (!redirectUrl) {
              throw new Error("No redirectUrl in Mollie response");
            }
            window.location.href = redirectUrl;
            return;
          }

          const shippingDate = this.isDelegue ? this.shippingDate : null;

          if (isMolliePaymentV2 && (!this.isVeterinaire || !this.isDelegue)) {
            const confirmedOrder = await completeOrder(orderToken, this.comment, shippingDate);
            checkoutStore.setOrder(confirmedOrder);
            const mollieResponse = await createMolliePayment(orderToken);

            // Check for success: false in 201/200 response
            if (mollieResponse?.data?.success === false) {
              const err = new Error(mollieResponse.data.error || "Mollie payment failed");
              err.response = mollieResponse;
              throw err;
            }

            const { data: { checkoutUrl } = {} } = mollieResponse || {};

            if (!checkoutUrl) {
              throw new Error("No checkoutUrl in Mollie response");
            }
            window.location.href = checkoutUrl;
            return;
          }

          // Default case: complete order and redirect
          const confirmedOrder = await completeOrder(orderToken, this.comment, shippingDate);
          checkoutStore.setOrder(confirmedOrder);
          cartStore.reintializeCart();

          delegueStore.clearSelectedVeterinarian();
          this.$router.push({ name: "paiement", params: { orderToken } });
        } catch (error) {
          console.error("Order confirmation error:", error.response?.data || error.message);

          const errorData = error.response?.data || {};
          const errorMessage = errorData.error || error.message || "";

          if (error.response?.status === 400 && errorData.detail) {
            this.toast.error(errorData.detail, {
              timeout: 10000,
            });
          } else if (
            errorMessage.includes("Veterinarian amount would be negative") ||
            errorMessage.includes("adjust pricing")
          ) {
            this.toast.error(
              "Une erreur de tarif a été détectée dans le catalogue de votre vétérinaire. Nous vous invitons à vous rapprocher de lui ou à nous contacter pour finaliser votre commande",
              {
                timeout: 10000,
              }
            );
          } else {
            this.toast.error("Une erreur est survenue lors de la confirmation de la commande. Veuillez réessayer.");
          }
        } finally {
          this.isProcessingOrder = false;
        }
      },
    },
  };
</script>

<style scoped>
  .livraison-page {
    padding: 15px;
    text-align: center;
    background: #f5f6f9;
    min-height: 500px;
  }

  .section-header-breadcrumb {
    text-align: left;
    font-style: normal;
    padding: 0 15px;
  }

  .section-header-breadcrumb .title-page {
    font-size: 30px;
    font-weight: bold;
    color: #1e347d;
  }

  .section-header-breadcrumb .breadcrumb-text {
    font-size: 15px;
    font-weight: normal;
  }

  .section-header-breadcrumb .breadcrumb-text span {
    color: #1e347d;
  }

  .step-cart {
    justify-content: center;
    margin-bottom: 3rem;
  }

  .title-blue {
    color: #1e347d;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }

  .step-cart-centent {
    justify-content: center;
    border: 1px solid #aeb1ba;
    border-radius: 10px;
  }

  .badge-blue {
    background-color: #1e347d !important;
    color: white !important;
    border-radius: 50%;
    font-size: 1.5rem;
  }

  .badge {
    background-color: #eee;
    color: #ec621a;
    border-radius: 50%;
    font-size: 1.5rem;
  }

  .step-cart .step-title {
    color: #000;
    font-weight: bold;
    font-size: 18px;
    opacity: 0.7;
  }

  .container-adresse {
    display: flex;
    justify-content: center;
    gap: 20px;
    padding: 20px;
    background-color: #f5f6f9;
    border-radius: 10px;
  }

  .adresse-card {
    flex: 1;
    border-right: 2px solid #aeb1ba;
    padding: 10px;
  }

  .adresse-card:last-child {
    border-right: none;
  }

  .title-blue {
    color: #363739;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .location {
    line-height: 1.5;
    text-align: left;
  }

  .detail-adresse {
    margin-left: 28px;
  }

  .shipping-icon {
    width: 20px;
    height: 20px;
  }

  .block-recap {
    background: white;
    text-align: left;
    padding: 30px;
    max-height: max-content;
    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: 0px 10px 6px rgba(0, 0, 0, 0.1);
  }

  .block-recap .title-recap {
    color: #1e347d;
    font-size: 20px;
    font-weight: bold;
  }

  .block-recap .recap-text {
    font-size: 20px;
  }

  .block-recap .recap-text-blue {
    font-size: 20px;
    color: #1e347d;
    font-weight: bold;
  }

  .block-recap .text-slogan {
    font-size: 12px;
    color: #1e347d;
    font-style: italic;
  }

  .divider {
    width: 90%;
    position: relative;
    left: 5%;
  }

  .error,
  .empty {
    color: #777;
    font-size: 1.2em;
  }

  .error {
    color: red;
    font-weight: bold;
  }

  .empty {
    color: #888;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    font-size: 1.2rem;
  }

  .spinner {
    border: 4px solid;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  .modal-width {
    max-width: 600px;
  }

  .padd-modal {
    padding: 20px 40px;
  }

  .close-link {
    background: none;
    border: none;
    font-size: 1.5rem;
    color: #6c757d;
  }

  .error-message {
    color: red;
    font-size: 0.8rem;
  }

  .success-message {
    color: green;
    font-size: 0.9rem;
  }

  .content-centered {
    margin: 0 auto;
  }

  .mollie-payment-types {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .mollie-payment-types .adress-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    border: 1px solid #ddd;
    border-radius: 10px;
    cursor: pointer;
  }

  .mollie-payment-types .adress-box.selected {
    border-color: #1e347d;
    background-color: #f0f4ff;
  }

  .mollie-payment-types .mode-left {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .mollie-payment-types .mode-right img {
    max-width: 50px;
    height: auto;
  }

  .shipping-date-section {
    background: white;
    padding: 20px;
    border-radius: 10px;
    border: 1px solid #ddd;
    margin-bottom: 20px;
  }

  .shipping-date-section h4 {
    margin-bottom: 15px;
    color: #1e347d;
  }

  .shipping-date-info {
    margin-top: 10px;
    padding: 10px;
    background-color: #f0f4ff;
    border-radius: 5px;
    border-left: 4px solid #1e347d;
  }

  .shipping-date-info strong {
    color: #1e347d;
  }

  .alert-warning {
    background-color: #fff3cd;
    border-color: #ffeaa7;
    color: #856404;
    padding: 12px;
    border-radius: 5px;
    font-size: 14px;
  }

  /* Responsive Styles pour mobiles uniquement - Même approche que les autres composants */
  @media (max-width: 768px) {
    /* Cacher step-cart-centent exactement comme dans les autres composants */
    .step-cart-centent {
      display: none !important;
    }

    .livraison-page {
      padding: 10px;
    }

    .section-header-breadcrumb {
      padding: 0 10px;
      text-align: center;
    }

    .section-header-breadcrumb .title-page {
      font-size: 24px;
      text-align: center;
    }

    .section-header-breadcrumb .breadcrumb-text {
      font-size: 14px;
      text-align: center;
    }

    .content.cart-page-inner {
      gap: 20px !important;
    }

    .block-adresses {
      margin-bottom: 1rem;
    }

    .step-cart {
      margin-bottom: 1.5rem;
    }

    .title-blue {
      font-size: 16px;
    }

    .shipping-icon {
      width: 18px;
      height: 18px;
    }

    .container-adresse {
      flex-direction: column;
      padding: 15px;
      gap: 15px;
    }

    .adresse-card {
      border-right: none;
      border-bottom: 2px solid #aeb1ba;
      padding: 15px 0;
    }

    .adresse-card:last-child {
      border-bottom: none;
    }

    .detail-adresse {
      margin-left: 0;
      font-size: 14px;
    }

    .block-recap {
      padding: 20px;
    }

    .block-recap .title-recap {
      font-size: 18px;
      text-align: center;
      display: block;
      width: 100%;
    }

    .block-recap .recap-text,
    .block-recap .recap-text-blue {
      font-size: 16px;
    }

    .btn-check-order {
      width: 100%;
      padding: 12px;
    }

    .back-link {
      display: inline-block;
      margin-bottom: 0.5rem;
    }

    .separator {
      display: none;
    }

    .shipping-date-section {
      padding: 15px;
    }

    .mollie-payment-types .adress-box {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }

    .mollie-payment-types .mode-right {
      align-self: flex-end;
    }

    .form-input textarea {
      font-size: 14px;
    }
  }

  @media (max-width: 576px) {
    .section-header-breadcrumb .title-page {
      font-size: 20px;
    }

    .breadcrumb-text {
      font-size: 13px !important;
    }

    .title-blue {
      font-size: 15px;
    }

    .block-recap {
      padding: 15px;
    }

    .block-recap .recap-text,
    .block-recap .recap-text-blue {
      font-size: 15px;
    }

    .detail-adresse {
      font-size: 13px;
    }

    .shipping-date-section {
      padding: 12px;
    }

    .mollie-payment-types .adress-box {
      padding: 12px;
    }
  }

  /* Pour les très petits écrans */
  @media (max-width: 360px) {
    .section-header-breadcrumb .title-page {
      font-size: 18px;
    }

    .breadcrumb-text {
      font-size: 12px !important;
    }

    .block-recap {
      padding: 12px;
    }

    .detail-adresse {
      font-size: 12px;
    }
  }
</style>
